export const ITEM_CREATIVE_TYPE = {
    STATIC_IMAGE: 'STATIC_IMAGE',
    PERFORMANCE_VIDEO: 'PERFORMANCE_VIDEO',
    DISPLAY: 'DISPLAY',
};
